import React from "react";

const SmallIcon = ({ children }) => {
  return React.cloneElement(children, { height: "16px", width: "16px" });
};

export default SmallIcon;
